<template>
  <div
    class="flex justify-center items-center flex-shrink-0 overflow-hidden text-sm font-medium text-pure-white"
    :style="avatar()"
    :class="[
      isActive ? 'bg-green-lime' : 'bg-light-purple-200',
      square ? 'rounded' : 'rounded-full'
    ]"
  >
    <div
      v-if="avatarUrl == '' || avatarUrl == null"
      class="capitalize"
      :style="{ fontSize: fontSize }"
    >
      {{ getInitial }}
    </div>
    <img
      v-else
      :src="avatarUrl"
      alt="avatar"
      class="rounded-full"
      :style="avatarThumb()"
    />
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    avatarUrl: {
      type: String,
      required: false,
      default: null
    },
    name: {
      typs: String,
      required: false,
      default: ""
    },
    size: {
      type: Number,
      required: false,
      default: 40
    },
    status: {
      type: String,
      required: false,
      default: "active"
    },
    square: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive() {
      return this.status === "active";
    },
    getInitial() {
      const name = this.name === "null" ? "" : this.name;
      return name ? name.charAt(0) : "";
    },
    fontSize() {
      return this.size / 2.5 + "px";
    }
  },
  methods: {
    avatar() {
      let n = Number(this.size);
      return {
        width: n + "px",
        height: n + "px",
        lineHeight: n + "px"
      };
      // return `width: ${n}px; height: ${n}px; line-height: ${n}px;`;
    },
    avatarThumb() {
      let n = Number(this.size);
      return {
        width: "100%",
        height: "auto",
        minWidth: n + "px",
        minHeight: n + "px"
      };
      // return `width: 100%; height: auto; min-width: ${n}px; min-height: ${n}px;`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Avatar.vue